@if (visible) {
    <form #stepForm="ngForm" class="form-page">
        <label>
            <span>{{ 'form.username' | translate }}</span>
            <input
                type="text"
                name="username"
                required
                [placeholder]="'form.username' | translate"
                [(ngModel)]="form.username"
            />
        </label>
        <label>
            <span>{{ 'form.emailAddress' | translate }}</span>
            <input
                #emailAddress="ngModel"
                type="text"
                name="emailAddress"
                required
                email
                [placeholder]="'form.emailAddress' | translate"
                [(ngModel)]="form.emailAddress"
            />
            @if (!emailAddress.valid) {
                <div class="form-error">
                    @if (emailAddress.errors?.usernameTaken) {
                        <div>
                            {{ 'validation.usernameTaken' | translate }}
                        </div>
                    }
                </div>
            }
        </label>
        <label>
            <span>{{ 'form.password' | translate }}</span>
            <input
                type="password"
                name="password"
                required
                minlength="8"
                (change)="checkPasswordsMatch()"
                [placeholder]="'form.password' | translate"
                [(ngModel)]="form.password"
            />
        </label>
        <label>
            <span>{{ 'form.passwordConfirm' | translate }}</span>
            <input
                type="password"
                name="passwordConfirm"
                required
                (change)="checkPasswordsMatch()"
                [placeholder]="'form.passwordConfirm' | translate"
                [(ngModel)]="form.passwordConfirm"
            />
        </label>
        <label>
            <input type="checkbox" name="termsAccepted" required [(ngModel)]="form.termsAccepted" />
            <span [innerHTML]="'form.termsAccepted' | translate: { termsUrl }"></span>
        </label>
        <button type="button" class="btn color-primary btn-login" (click)="redirectToLogin()">
            <span>{{ 'buttons.backToLogin' | translate }}</span>
        </button>
    </form>
}
